export const getRoundingField = (key: string) => {
  return `jbp-${key || ''}-rounding`.replace(/\s/g, '').toLowerCase()
}
